module.exports = __webpack_public_path__ + "img/suzhounsyh.eeb221cb.png";